import * as React from "react"
import {useEffect} from "react"
import {number, object} from "yup";
import {useComputed, useSignal} from "@preact/signals-react";
import {useValidatorSeeker} from "@ui-seeker/app";

import {useMatchersSkusCreateLine, useMatchersSkusForm} from "../../../@hooks";
import {matcherSKUDrawerData, matcherSKUDrawerError} from "../../../@signals";
import CreateLineForm from "./CreateLineForm";
import LineSelector from "./LineSelector";


export default function MatchersSKUsDrawerLine() {
	const createMode = useSignal(false)
	const category = useComputed(() => matcherSKUDrawerData.value.categoryID)
	const company = useComputed(() => matcherSKUDrawerData.value.companyID)
	const brand = useComputed(() => matcherSKUDrawerData.value.brandID)

	const { localValue, handleChange } = useMatchersSkusForm('lineID')
	const brandID = useMatchersSkusForm('brandID').localValue
	const { lineName, isLoading, handleLineName, handleSubmit, reset } = useMatchersSkusCreateLine()

	const { errors } = useValidatorSeeker({
		lineID: localValue
	}, object({
		lineID: number().required('Line is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			lineID: errors?.lineID
		}
	}, [errors?.lineID]);

	const handleCreateLine = async () => {
		const response = await handleSubmit(brandID)
		if (response?.lineID) {
			handleChange(response.lineID)
		}
		createMode.value = false
	}

	const toggleCreateMode = () => {
		if (createMode.value) {
			reset()
		}
		createMode.value = !createMode.value
	}

	if (createMode.value) {
		return <CreateLineForm
			lineName={lineName}
			isLoading={isLoading}
			onLineNameChange={handleLineName}
			onSave={handleCreateLine}
			onCancel={toggleCreateMode}
		/>
	}

	return <LineSelector
		value={localValue}
		onChange={newValue => handleChange(newValue.target.value)}
		disabled={!brandID}
		error={errors?.lineID}
		filters={{
			category: category.value || '',
			company: company.value || '',
			brand: brand.value || ''
		}}
		onCreateClick={toggleCreateMode}
		canCreate={!!brandID}
	/>
}
